import React from "react";
import "./ContactUsSection.css";

const ContactUsSection = () => {
  return (
    <section className="contact-section">

      <div className="contact-container">

        <div className="contact-header">
          <h2>Contact Us</h2>
          <p>
            Have questions about RippleRun? Our team is ready to assist you.
          </p>
        </div>

        <div className="contact-grid">

          {/* Email Card */}
          <a
            href="mailto:customerservice@unichemghana.com"
            className="contact-card"
          >
            <div className="contact-icon">📧</div>
            <h3>Email Us</h3>
            <p>customerservice@unichemghana.com</p>
          </a>

          {/* Phone Card */}
          <a
            href="tel:+233 531 065 015"
            className="contact-card"
          >
            <div className="contact-icon">📞</div>
            <h3>Call Us</h3>
            <p>+233 531 065 015 / +233 302 739 009</p>
          </a>

        </div>

      </div>

    </section>
  );
};

export default ContactUsSection;